import { render, staticRenderFns } from "./PhysicalExaminationGuidance.vue?vue&type=template&id=799b1b96&scoped=true&"
import script from "./PhysicalExaminationGuidance.vue?vue&type=script&lang=js&"
export * from "./PhysicalExaminationGuidance.vue?vue&type=script&lang=js&"
import style0 from "./PhysicalExaminationGuidance.vue?vue&type=style&index=0&id=799b1b96&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "799b1b96",
  null
  
)

export default component.exports